"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayOutput = void 0;
var plain_text_1 = require("../format/plain-text");
var output_1 = require("./output");
var firstIndent = '  | ';
var nextIndent = '   ';
var arrayOutput = function (options) {
    var indent = '';
    var out = options.out;
    var fakeConsole = {
        log: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            out.push("".concat(indent).concat(args.join(' ')));
        },
        group: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            out.push("".concat(indent).concat(args.join(' ')));
            indent = indent ? "".concat(nextIndent).concat(indent) : firstIndent;
        },
        groupEnd: function () {
            indent = indent === firstIndent ? '' : firstIndent.slice(nextIndent.length);
        },
        groupCollapsed: function () {
            fakeConsole.groupEnd();
        },
    };
    return (0, output_1.createOutput)({
        out: fakeConsole,
        format: options.format || plain_text_1.plainTextFormat,
    });
};
exports.arrayOutput = arrayOutput;
//# sourceMappingURL=array.js.map